import { Box, styled } from '@creditas-ui/react'

export const ContentResumeDetailStyle = styled(Box)`
  width: 100%;
  padding: 0 20px;

  @media screen and (min-width: 980px) {
    padding: 0;
  }
`

export const GridItems = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const ItemInformation = styled(Box)`
  margin-bottom: 24px;
`
